// Raccourci pour les sélecteurs
const $ = document.querySelector.bind(document);
const $$ = document.querySelectorAll.bind(document);
